<template>
  <div v-if="visible" class="overlay">
    <!-- Full-screen video background -->
    <video v-if="characterSrc" class="character" autoplay playsinline @ended="onVideoEnded">
      <source :src="characterSrc" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    
    <!-- Skip intro button that appears after 2 seconds -->
    <button 
      v-show="showSkipButton"
      class="close-button" 
      @click="startGame"
    >
    {{skip_label[language]}}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      language: 'en',
      skip_label: {en: "Skip", el: "Παράλειψη", it: "Salta", ro: "Sari peste", uk: "Пропустити"},
      showSkipButton: false, // Track visibility of the skip button
      audio: null, // Reference to the audio object
      buttonClickSound: new Audio(require('@/assets/sounds/click-345983.mp3')),
    };
  },
  computed: {
    // Video source
    characterSrc() {
      return require(`@/assets/cinematic/${this.language}_cinematic.mp4`); // Update with the correct path to your video
    },
  },
  methods: {
    // Trigger the game start and close the overlay
    startGame() {
      this.buttonClickSound.currentTime = 0;
      this.buttonClickSound.play();
      this.stopAudio();  // Stop the audio
      this.closeOverlay();  // Close the overlay
      this.$emit('start-game'); // Emit the event to start the game
    },

    // Close the overlay and emit visibility change
    closeOverlay() {
      this.$emit('update:visible', false); // Emit the event to change the visibility
    },

    // Stop the audio
    stopAudio() {
      if (this.audio) {
        this.audio.pause(); // Pause the audio
        this.audio.currentTime = 0; // Reset the audio to the beginning
      }
    },

    // Triggered when the video ends
    onVideoEnded() {
      this.startGame(); // Automatically start the game when video ends
    },
  },
  created()
  {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },
  mounted() {
    // this.audio = new Audio(require('@/assets/sounds/SavingVitaliaCinematicAudio.mp3')); // Initialize the audio reference
    // this.audio.play().catch((error) => {
    //   console.error("Error playing sound:", error);
    // });

    // Show skip button after 2 seconds
    setTimeout(() => {
      this.showSkipButton = true;
    }, 2000); // 2 seconds delay for the skip button
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-out;
}

.character {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the video covers the entire screen */
  animation: fadeIn 1s ease-out;
}

.close-button {
  position: fixed;
  top: 5%;
  right: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 1.2rem;
  padding: 10px 20px;
  cursor: pointer;
  z-index: 2010; /* Ensure the button is on top of the overlay */
  transition: all 0.3s ease;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  max-width: 180px;
}

.close-button:hover {
  background-color: #0077cc;
  transform: scale(1.1);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
